import { useState } from "react";
function useModal() {
  const [show, setShow] = useState(false);
  const toggle = (state) => setShow(state);
  return [show, toggle];
}
export default useModal;
